"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useMediaSession = function (videoState, player, onPlayRequested, onPauseRequested, onNextVideoRequested) {
    (0, react_1.useEffect)(function () {
        if (!navigator.mediaSession)
            return;
        var playbackState = !videoState.paused ? 'playing' : 'paused';
        navigator.mediaSession.playbackState = playbackState;
        return function () {
            navigator.mediaSession.playbackState = 'none';
        };
    }, [videoState.paused]);
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d, _e;
        if (!navigator.mediaSession)
            return;
        var metaItem = player.metaItem && ((_a = player.metaItem) === null || _a === void 0 ? void 0 : _a.type) === 'Ready' ? player.metaItem.content : null;
        var videoId = player.selected ? (_d = (_c = (_b = player.selected) === null || _b === void 0 ? void 0 : _b.streamRequest) === null || _c === void 0 ? void 0 : _c.path) === null || _d === void 0 ? void 0 : _d.id : null;
        var video = metaItem === null || metaItem === void 0 ? void 0 : metaItem.videos.find(function (_a) {
            var id = _a.id;
            return id === videoId;
        });
        var videoInfo = (video === null || video === void 0 ? void 0 : video.season) && (video === null || video === void 0 ? void 0 : video.episode) ? " (".concat(video.season, "x").concat(video.episode, ")") : null;
        var videoTitle = video ? "".concat(video.title).concat(videoInfo) : null;
        var metaTitle = metaItem ? metaItem.name : null;
        var imageUrl = metaItem ? metaItem.logo : null;
        var title = videoTitle !== null && videoTitle !== void 0 ? videoTitle : metaTitle;
        var artist = (_e = (videoTitle && metaTitle)) !== null && _e !== void 0 ? _e : undefined;
        var artwork = imageUrl ? [{ src: imageUrl }] : undefined;
        if (title) {
            navigator.mediaSession.metadata = new MediaMetadata({
                title: title,
                artist: artist,
                artwork: artwork,
            });
        }
    }, [player.metaItem, player.selected]);
    (0, react_1.useEffect)(function () {
        if (!navigator.mediaSession)
            return;
        navigator.mediaSession.setActionHandler('play', onPlayRequested);
        navigator.mediaSession.setActionHandler('pause', onPauseRequested);
        var nexVideoCallback = player.nextVideo ? onNextVideoRequested : null;
        navigator.mediaSession.setActionHandler('nexttrack', nexVideoCallback);
    }, [player.nextVideo, onPlayRequested, onPauseRequested, onNextVideoRequested]);
};
exports.default = useMediaSession;
